"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicrosoftADProvider = void 0;
var constants_1 = require("../constants");
var auth_error_1 = require("../model/auth.error");
var auth_user_1 = require("../model/auth.user");
var user_session_1 = require("../model/user.session");
var user_info_1 = require("../model/user.info");
var model_1 = require("../model");
var msal_browser_1 = require("@azure/msal-browser");
var jwt_decode_1 = require("jwt-decode");
var ACCESS_TOKEN = 'accesstoken';
var createAuthUser = function (idToken, accessToken, locale) {
    var decodedAccessToken = jwt_decode_1.default(accessToken);
    var decodedIdToken = jwt_decode_1.default(idToken);
    var appid = decodedAccessToken.appid ? decodedAccessToken.appid :
        decodedAccessToken.aud.includes('api://') ? decodedAccessToken.aud.split('://')[1] : decodedAccessToken.aud;
    if (decodedAccessToken) {
        var customAttributesList = Object.keys(decodedAccessToken).
            filter(function (key) { return key.includes('extn.'); });
        var customAttributes_1 = {};
        customAttributes_1["appId"] = appid;
        if (customAttributesList.length) {
            customAttributesList.map(function (attribute) {
                var attri = attribute.replace("extn.", "");
                customAttributes_1["APP_LOGGED_IN_USER_CONTEXT_" + attri] = decodedAccessToken[attribute] && decodedAccessToken[attribute][0] ? decodedAccessToken[attribute][0] : "Not Mapped Yet";
            });
        }
        var userInfo = {
            preferred_username: decodedAccessToken.preferred_username,
            family_name: decodedAccessToken.family_name,
            given_name: decodedAccessToken.given_name,
            email: decodedAccessToken.email,
            name: decodedAccessToken.name,
            sub: decodedAccessToken.sub,
            oid: decodedAccessToken.oid,
            profile: 'ACTIVE',
            role: decodedAccessToken.roles,
            customAttributes: customAttributes_1,
        };
        var sessions = new user_session_1.default(idToken, accessToken, locale);
        var authUser = new auth_user_1.default(decodedIdToken.preferred_username, new user_info_1.UserInfo(decodedIdToken.sub, decodedAccessToken.oid, userInfo), sessions);
        return authUser;
    }
    throw new Error('sub or userName attrb is missing');
};
var MicrosoftADProvider = /** @class */ (function () {
    function MicrosoftADProvider(config) {
        this.config = config;
        var microsoftADConfig = config.provider[config.provider.type];
        this.authClient = new msal_browser_1.PublicClientApplication(microsoftADConfig);
        this.account = null;
        this.setRequestObjects(config);
    }
    MicrosoftADProvider.prototype.setRequestObjects = function (config) {
        var _this = this;
        this.loginRequest = {
            scopes: ["openid", "profile"]
        };
        this.silentProfileRequest = {
            scopes: ["openid", "profile"],
            account: this.account,
            forceRefresh: false
        };
        if (config.provider[config.provider.type].customScope.length) {
            config.provider[config.provider.type].customScope.map(function (scope) {
                _this.loginRequest.scopes.push(scope);
                _this.silentProfileRequest.scopes.push(scope);
            });
        }
    };
    MicrosoftADProvider.prototype.getAccount = function (userName) {
        // need to call getAccount here?
        var currentAccounts = this.authClient.getAllAccounts();
        if (currentAccounts === null || currentAccounts.length === 0) {
            return null;
        }
        if (currentAccounts.length > 1) {
            for (var _i = 0, currentAccounts_1 = currentAccounts; _i < currentAccounts_1.length; _i++) {
                var userAccount = currentAccounts_1[_i];
                if (userAccount.homeAccountId.split(".")[0] === userName) {
                    return userAccount;
                }
            }
        }
        else if (currentAccounts.length === 1) {
            return currentAccounts[0];
        }
    };
    MicrosoftADProvider.prototype.handleResponse = function (response, userName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (response !== null) {
                    this.account = response.account;
                }
                else {
                    this.account = this.getAccount(userName);
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Log In
     * @param username
     * @param password
     */
    MicrosoftADProvider.prototype.signIn = function (userName, password, locale) {
        return __awaiter(this, void 0, void 0, function () {
            var resp, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        //Before doing login clear cache for msal browser
                        this.authClient.browserStorage.temporaryCacheStorage.windowStorage.clear();
                        return [4 /*yield*/, this.authClient.loginPopup(this.
                                loginRequest)];
                    case 1:
                        resp = _a.sent();
                        return [4 /*yield*/, this.handleResponse(resp, resp.uniqueId)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, createAuthUser(resp.idToken, resp.accessToken, locale)];
                    case 3:
                        e_1 = _a.sent();
                        console.log("::::::::::::::::::::::::::::::::::::::::::::", e_1.message);
                        switch (e_1.errorCode) {
                            case 'interaction_required':
                            case 'consent_required':
                            case 'login_required':
                                throw new auth_error_1.default(e_1.errorMessage);
                            default:
                                throw e_1;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sign up with username, password and other attrbutes like phone, email
     * @param params
     */
    MicrosoftADProvider.prototype.signUp = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var res, apiError;
            return __generator(this, function (_a) {
                try {
                    res = {
                        sub: '',
                        preferred_username: '',
                        isUserConfirmed: false
                    };
                    return [2 /*return*/, res];
                }
                catch (e) {
                    apiError = e.errorResponse.errors && e.errorResponse.errors.length
                        ? e.errorResponse.errors[0]
                        : undefined;
                    if (!apiError) {
                        throw e;
                    }
                    switch (apiError.reason) {
                        case constants_1.ErrorCodeEnum.INVALID_EMAIL_FORMAT:
                            throw new auth_error_1.default(apiError.message, constants_1.ErrorCodeEnum.INVALID_EMAIL_FORMAT);
                        case constants_1.ErrorCodeEnum.WEAK_PASSWORD:
                            throw new auth_error_1.default(apiError.message, constants_1.ErrorCodeEnum.WEAK_PASSWORD);
                        default:
                            throw new auth_error_1.default(e.message, constants_1.ErrorCodeEnum.SYSTEM_ERROR);
                    }
                    throw e;
                }
                return [2 /*return*/];
            });
        });
    };
    MicrosoftADProvider.prototype.signUpUserProfile = function (params, res) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                }
                catch (e) {
                    throw e;
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Send the verification code to confirm sign up
     * @param username
     * @param code
     */
    MicrosoftADProvider.prototype.confirmSignUp = function (userName, code, transactionId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, 'SUCCESS'];
                }
                catch (e) {
                    throw e;
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Request to resend the verification code
     * @param username
     */
    MicrosoftADProvider.prototype.resendSignUp = function (username) {
        return __awaiter(this, void 0, void 0, function () {
            var delivery;
            return __generator(this, function (_a) {
                try {
                    delivery = {
                        attributeName: '',
                        deliveryMedium: '',
                        destination: ''
                    };
                    return [2 /*return*/, delivery];
                }
                catch (e) {
                    throw e;
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * logout
     */
    MicrosoftADProvider.prototype.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            var logOutRequest;
            return __generator(this, function (_a) {
                logOutRequest = {
                    account: this.account
                };
                this.authClient.logout(logOutRequest);
                return [2 /*return*/, 'SUCCESS'];
            });
        });
    };
    /**
     * Change password by authenticated user
     * @param user
     * @param oldPassword
     * @param newPassword
     */
    MicrosoftADProvider.prototype.changePassword = function (userName, oldPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, 'SUCCESS'];
                }
                catch (e) {
                    throw e;
                }
                return [2 /*return*/, 'SUCCESS'];
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param username
     */
    MicrosoftADProvider.prototype.forgotPassword = function (userName) {
        return __awaiter(this, void 0, void 0, function () {
            var delivery;
            return __generator(this, function (_a) {
                try {
                    delivery = {
                        attributeName: '',
                        deliveryMedium: '',
                        destination: ''
                    };
                    return [2 /*return*/, delivery];
                }
                catch (e) {
                    throw e;
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param username
     * @param code
     * @param password
     */
    MicrosoftADProvider.prototype.forgotPasswordSubmit = function (userName, code, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, 'SUCCESS'];
                }
                catch (e) {
                    throw e;
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Get current authenticated user
     * @param params
     */
    MicrosoftADProvider.prototype.currentAuthenticatedUser = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.account) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.handleResponse(null, '')];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.silentProfileRequest.account = this.account;
                        return [4 /*yield*/, this.authClient.acquireTokenSilent(this.silentProfileRequest)];
                    case 3:
                        response = _a.sent();
                        if (response.idToken && response.accessToken) {
                            return [2 /*return*/, createAuthUser(response.idToken, response.accessToken, 'en')];
                        }
                        else {
                            throw new auth_error_1.default(constants_1.AuthMessageEnum.USER_NOT_LOGGEDIN, constants_1.ErrorCodeEnum.USER_NOT_LOGGEDIN);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get current user's session
     */
    MicrosoftADProvider.prototype.currentSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.account) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.handleResponse(null, '')];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.silentProfileRequest.account = this.account;
                        return [4 /*yield*/, this.authClient.acquireTokenSilent(this.silentProfileRequest)];
                    case 3:
                        response = _a.sent();
                        if (response.idToken && response.accessToken) {
                            return [2 /*return*/, new model_1.UserSession(new model_1.JWTToken(response.idToken), new model_1.JWTToken(response.accessToken), ' ')];
                        }
                        else {
                            throw new auth_error_1.default(constants_1.AuthMessageEnum.USER_NOT_LOGGEDIN, constants_1.ErrorCodeEnum.USER_NOT_LOGGEDIN);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     *
     * @param user Update user attributes
     * @param attributes
     */
    MicrosoftADProvider.prototype.updateUserAttributes = function (user, attributes) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, 'SUCCESS'];
            });
        });
    };
    return MicrosoftADProvider;
}());
exports.MicrosoftADProvider = MicrosoftADProvider;
var microsoftADProvider;
var createMicrosoftADProvider = function (config) {
    if (microsoftADProvider === null || microsoftADProvider === undefined) {
        microsoftADProvider = new MicrosoftADProvider(config);
    }
    return microsoftADProvider;
};
exports.default = createMicrosoftADProvider;
//# sourceMappingURL=microsoft-ad.auth.provider.js.map